export default __webpack_public_path__ + "static/media/next-move-en_80.4b4ce9b0.gif";